export default __webpack_public_path__ + "static/media/sleep.456e9262.svg";